module.exports = __webpack_public_path__ + "static/media/Profile.29a93881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NavIcons/Profile.png
// module id = 592
// module chunks = 0